var map = {
	"./ambulance.svg": 2305,
	"./atb/arrow-back-atb.svg": 4510,
	"./atb/arrow-down-atb.svg": 5959,
	"./atb/calendar-atb.svg": 8918,
	"./atb/logo-atb.svg": 6872,
	"./atb/shield-atb.svg": 9085,
	"./building.svg": 9365,
	"./check-white.svg": 7818,
	"./check.svg": 2542,
	"./coins.svg": 6130,
	"./court.svg": 2919,
	"./cross.svg": 7460,
	"./doctors.svg": 4798,
	"./dropdown.svg": 2340,
	"./gosuslugi-login.svg": 3074,
	"./gosuslugi.svg": 57,
	"./handshake.svg": 5616,
	"./hospital.svg": 8176,
	"./howto-1.svg": 2228,
	"./howto-2.svg": 5505,
	"./howto-3.svg": 1302,
	"./idcard.svg": 9940,
	"./list-percent.svg": 4834,
	"./lock-rouble.svg": 1924,
	"./logo-makc-blue.svg": 8313,
	"./logo-sm-square.svg": 6111,
	"./logo-square.svg": 8184,
	"./logo.svg": 2900,
	"./msg-question.svg": 3216,
	"./ok-circled.svg": 9357,
	"./otp/info-otp.svg": 4105,
	"./otp/logo-otp.svg": 4017,
	"./person.svg": 1391,
	"./plus.svg": 3753,
	"./rouble.svg": 7797,
	"./schedule.svg": 5278,
	"./shield-check.svg": 7871,
	"./shield-rouble.svg": 8961,
	"./shield.svg": 6419,
	"./thumbs-up.svg": 9681,
	"./truck.svg": 4721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1041;